<div
  class="bm-header-btn-wrapper"
  [ngClass]="{ 'bm-header-btn-wrapper--wl-mode': wlMode }"
>
  <button
    class="bm-button bm-open-button"
    (click)="openPopup($event)"
    [ngClass]="{
      'bm-open-button--active': opened,
      'bm-open-button--text': !boxBtnMode,
      'bm-open-button--box': boxBtnMode
    }"
    *ngIf="redeemedCoupons.length > 0 || activeCoupons.length > 0"
  >
    <i>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.41163 10.6879C1.71936 9.41077 3.66764 8.35467 4.35991 9.63177C3.66764 8.35467 5.61591 7.29858 6.30818 8.57567C5.61591 7.29858 7.56419 6.24248 8.25646 7.51958C7.56419 6.24248 9.51247 5.18639 10.2047 6.46349C9.51247 5.18639 11.4607 4.1303 12.153 5.40739C11.4607 4.1303 13.409 3.0742 14.1013 4.3513C13.409 3.0742 15.3573 2.01811 16.0496 3.2952C15.3573 2.01811 17.3056 0.962015 17.9978 2.23911L22.8524 11.1948C23.5447 12.4719 21.5964 13.528 20.9042 12.2509C21.5964 13.528 19.6482 14.5841 18.9559 13.307C19.6482 14.5841 17.6999 15.6402 17.0076 14.3631C17.6999 15.6402 15.7516 16.6963 15.0593 15.4192C15.7516 16.6963 13.8033 17.7524 13.1111 16.4753C13.8033 17.7524 11.8551 18.8085 11.1628 17.5314C11.8551 18.8085 9.90678 19.8646 9.21451 18.5875C9.90678 19.8646 7.9585 20.9207 7.26623 19.6436C7.9585 20.9207 6.01022 21.9768 5.31795 20.6997L0.463355 11.744C-0.228915 10.4669 1.71936 9.41077 2.41163 10.6879ZM13.6804 6.44334L10.5944 16.7799L9.63409 16.4963L12.72 6.15969L13.6804 6.44334ZM9.16079 8.74857C9.66477 8.89743 10.06 9.23697 10.2916 9.66422C10.5236 10.0922 10.5912 10.6083 10.4417 11.1115C10.2917 11.6138 9.95105 12.01 9.52179 12.2427C9.09252 12.4754 8.57507 12.5454 8.07184 12.3961C7.56905 12.2476 7.17383 11.908 6.94181 11.48C6.7098 11.052 6.641 10.5355 6.79098 10.0332C6.94095 9.53081 7.28277 9.13496 7.71127 8.90269C8.14053 8.67 8.65798 8.60005 9.16079 8.74857ZM8.82352 9.87828C8.63169 9.82162 8.43464 9.84762 8.27145 9.93608C8.10826 10.0245 7.9797 10.175 7.92171 10.3671C7.82362 10.6957 7.94104 10.9603 8.14405 11.1207C8.22317 11.1835 8.31554 11.2303 8.41324 11.2591C8.51094 11.288 8.61278 11.2986 8.714 11.2897C8.97013 11.2656 9.21294 11.108 9.31098 10.7775C9.3682 10.5858 9.34188 10.3896 9.25367 10.2268C9.16547 10.0641 9.01539 9.93495 8.82356 9.87829L8.82352 9.87828ZM15.2418 10.5441C15.7458 10.693 16.141 11.0325 16.3726 11.4597C16.6046 11.8878 16.673 12.4034 16.5226 12.907C16.3727 13.4094 16.0316 13.8048 15.6024 14.0375C15.1731 14.2702 14.6564 14.3397 14.1528 14.1916C13.65 14.0431 13.2548 13.7036 13.0228 13.2755C12.7908 12.8475 12.722 12.3311 12.872 11.8287C13.0219 11.3263 13.3626 10.9301 13.7918 10.6974C14.2211 10.4648 14.7385 10.3948 15.2418 10.5441ZM14.9045 11.6738C14.7127 11.6171 14.5156 11.6431 14.3524 11.7316C14.19 11.8196 14.0607 11.9706 14.0027 12.1626C13.9046 12.4912 14.022 12.7558 14.225 12.9162C14.3042 12.9791 14.3965 13.0258 14.4942 13.0547C14.5919 13.0835 14.6938 13.0942 14.795 13.0852C15.0519 13.0607 15.2935 12.9028 15.392 12.573C15.4492 12.3813 15.4236 12.1847 15.3354 12.022C15.2472 11.8592 15.0971 11.7301 14.9046 11.6738L14.9045 11.6738Z"
          class="bm-open-button-svg-path"
        />
      </svg>
    </i>
    <div class="text">
      <span>{{ 'your-coupons' | translate }}</span>
      <span *ngIf="!wlMode">({{ count }})</span>
      <span *ngIf="wlMode" class="bm-alert-count">{{ count }}</span>
    </div>
  </button>

  <div class="popup" *ngIf="opened" (clickOutside)="toggleMenu.next(false)">
    <div class="corner"></div>
    <div class="cut-corner"></div>
    <h5 [translate]="'your-coupons'" [translateParams]="{ count: count }"></h5>
    <div class="lists-container">
      <div class="list" *ngIf="activeCoupons.length > 0">
        <h6>Active</h6>
        <app-activity
          *ngFor="let coupon of activeCoupons"
          [item]="coupon"
          [itemWidth]="336"
          [forPopup]="true"
        ></app-activity>
      </div>
      <div class="list" *ngIf="redeemedCoupons.length > 0">
        <h6>Redeemed</h6>
        <app-activity
          *ngFor="let coupon of redeemedCoupons"
          [item]="coupon"
          [itemWidth]="336"
          [forPopup]="true"
        ></app-activity>
      </div>
    </div>
  </div>
</div>
